import { IPhoneEditor } from 'legacy/lut/components/widgets/public/phoneEditor/models'

import { OnboardingPhoneEditor } from 'onboarding/components/ui/theme'
import { TAdaptingDisabled } from 'onboarding/components/ui/visualAudienceAdapters/types'

export const OnboardingPhoneEditorAdapter = ({
  disabled,
  isDisabled,
  ...props
}: IPhoneEditor & TAdaptingDisabled) => (
  <OnboardingPhoneEditor {...props} isDisabled={isDisabled || disabled} />
)
